import { useCallback, useEffect, useState } from 'react';
import { getContactInformation } from '../services/contact';

export function useContactInformation() {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchContact = useCallback(async () => {
    setLoading(true);

    try {
      const res = await getContactInformation();
      setContact(res?.data || null);
    } catch {
      setContact(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchContact().catch(() => {});
  }, [fetchContact]);

  return { contact, loading, refetch: fetchContact };
}
